import React, { useEffect, useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import { TextField, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  CreateClientsAction,
  DeleteClientsMowakelAction,
  GetAllClientsMowakelAction,
  UpdateClientsMowakelAction,
} from "../../../../redux/actions/ClientAction";
import { ToastContainer } from "react-toastify";
import notify from "../../../Notifcation";
import axios from "axios";
import fileDownload from "js-file-download";
import Pagination from "../../../Utility/Pagination/Pagination";
const Namemowakel = ({ userData }) => {
  const [Namee, setNamee] = useState("");
  const [Phone, setPhone] = useState("");
  const [Addreess, setAddreess] = useState("");
  const [Note, setNote] = useState("");
  const [NoteImg, setNoteImg] = useState("");

  const [Search, setSearch] = useState("");

  const [IDTawkelMO, setIDTawkelMO] = useState("");
  const [Eye, setEye] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedFile, setSelectedFile] = useState("");
  const [isPress, setIsPress] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [showDelete, setshowDelete] = useState(false);
  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setIDTawkelMO(itemid);
  };
  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteClientsMowakelAction(IDTawkelMO));
    setLoading(false);
    setIDTawkelMO("");

    setshowDelete(false);
    setIsPress(false);
  };
  const PageSize = 2000;

  const ALL = useSelector((state) => state.ClientR.GetClientsMo);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      GetAllClientsMowakelAction(
        `SearchTerm=${Search}&PageSize=${PageSize}&ClientType=Client`
      )
    );
  }, [Search]);
  const [FileeBase64, setBase64] = useState("");
  const onPress = async (page) => {
    await dispatch(
      GetAllClientsMowakelAction(
        `PageNumber=${page}&PageSize=${PageSize}&ClientType=Client`
      )
    );
  };
  function formatFileSize(bytes) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  }

  function importData() {
    let input = document.createElement("input");
    input.type = "file";
    input.multiple = "false";

    if (userData.UsedSize >= userData.SubscriptionSizeOnS3) {
      notify(
        "تم استهلاك باقة الارشيف لزيادة السعة التخزينية التواصل معنا",
        "warn"
      );
      return;
    }
    input.onchange = (e) => {
      setSelectedFile(e.target.files[0]);
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result;
        setBase64(base64);
      };
      reader.readAsDataURL(e.target.files[0]);
    };
    // }

    input.click();
  }
  const deleteFile = () => {
    setSelectedFile("");
    setBase64("");
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (Namee === "" || Phone === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    if (selectedFile && selectedFile.size > 5000000) {
      notify("من فضلك يجب ان يكون حجم الملف 5 ميجا او اقل  ", "error");
      return;
    }
    if (userData.SubscriptionType === "Ended-Subscription") {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.IsActive === false &&
      userData.SubscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.IsActive === false &&
      userData.SubscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.SubscriptionType === "User-not-subscriped" &&
      ALL.Data &&
      ALL.Data.length > 4
    ) {
      notify("غير مسموح بأضافة اكثر من 5 حركة إشترك للتفعيل ", "error");
      return;
    }
    if (
      userData.SubscriptionType === "Subscription-not-approved" &&
      ALL.Data &&
      ALL.Data.length > 4
    ) {
      notify("غير مسموح بأضافة اكثر من 5 حركة إشترك للتفعيل ", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    const formData = new FormData();
    formData.append("Name", Namee);
    formData.append("phoneNumber", Phone);
    formData.append("Address", Addreess);
    formData.append("Note", Note);
    formData.append("ClientType", "Client");
    formData.append("FileDescription", NoteImg);

    formData.append("File", selectedFile);

    await dispatch(CreateClientsAction(formData));
    setNamee("");
    setNote("");
    setAddreess("");
    setPhone("");
    setSelectedFile("");
    setBase64("");
    setIsPress(false);
    setLoading(false);
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (Namee === "" || Phone === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    if (selectedFile && selectedFile.size > 5000000) {
      notify("من فضلك يجب ان يكون حجم الملف 5 ميجا او اقل  ", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    const formData = new FormData();
    formData.append("Id", IDTawkelMO);
    formData.append("Name", Namee);
    formData.append("phoneNumber", Phone);
    formData.append("Address", Addreess);
    formData.append("Note", Note);
    formData.append("ClientType", "Client");
    formData.append("FileDescription", NoteImg);
    formData.append("NewFile", selectedFile);
    await dispatch(UpdateClientsMowakelAction(formData));
    setNamee("");
    setNote("");
    setAddreess("");
    setPhone("");
    setSelectedFile("");
    setBase64("");
    setIDTawkelMO("");
    setIsEdit(false);
    setIsPress(false);
    setLoading(false);
  };
  const Update = (item) => {
    setNamee(item.Name);
    setNote(item.Note);
    setNoteImg(item.FileDescription === null ? "" : item.FileDescription);
    setAddreess(item.Address);
    setPhone(item.phoneNumber);
    setSelectedFile(item.FileUrl);
    setIDTawkelMO(item.Id);
    setIsEdit(true);
    setEye(false);
  };
  const HandleEye = (item) => {
    setNamee(item.Name);
    setNote(item.Note);
    setNoteImg(item.FileDescription === null ? "" : item.FileDescription);
    setAddreess(item.Address);
    setPhone(item.phoneNumber);
    setSelectedFile(item.FileUrl);
    //setIDTawkelMO(item.Id);
    setIsEdit(false);
    setEye(true);
  };
  const res = useSelector((state) => state.ClientR.InsertClients);
  const UP = useSelector((state) => state.ClientR.UpdateClientsMo);
  const DEL = useSelector((state) => state.ClientR.DeleteClientsMo);
  // const UP = useSelector((state) => state.ClientR.UpdateAgencyStatus);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (
            res.data &&
            res.data.ResponseMessage === "Great, Client created Successfully"
          ) {
            dispatch(GetAllClientsMowakelAction("ClientType=Client"));
            notify("تم اضافة البيانات بنجاح", "success");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (UP) {
        if (UP.status === 200 || UP.status === 201) {
          if (
            UP.data &&
            UP.data.ResponseMessage === "Great, client updated successfully"
          ) {
            dispatch(GetAllClientsMowakelAction("ClientType=Client"));
            notify("تم تحديث البيانات بنجاح", "success");
          }
        } else if (UP.status !== 200 || UP.status !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }

      if (DEL) {
        if (DEL.StatusCode === 200 || DEL.StatusCode === 201) {
          if (
            DEL &&
            DEL.ResponseMessage === "Great, client deleted Successfully"
          ) {
            dispatch(GetAllClientsMowakelAction("ClientType=Client"));
            notify("تم حذف الموكل بنجاح", "success");
          }
        } else if (DEL.StatusCode !== 200 || DEL.StatusCode !== 201) {
          if (
            DEL &&
            DEL.ResponseMessage === "Can't delete because you are using it"
          ) {
            notify("لا يمكن حذف هذا الموكل لانة مربوط بتوكيل", "warn");
          } else notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  const [popup, setpopup] = useState(false);
  const [ContentFile, setContentFile] = useState("");
  const handleClosepopup = () => {
    setpopup(false);
    setpopup("");
    setContentFile("");
  };
  const handleShowpopup = (item) => {
    setpopup(true);
    setContentFile(item);
  };
  const handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
        setpopup(false);
      });
  };
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <TextField
                inputProps={{ maxLength: 120 }}
                type="text"
                value={Namee}
                onChange={(e) => setNamee(e.target.value)}
                label={
                  <Typography sx={{ fontSize: "17", fontFamily: "Almarai" }}>
                    اسم الموكل
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                value={Phone}
                inputProps={{ maxLength: 15 }}
                type="number"
                onChange={(e) => setPhone(e.target.value)}
                label={
                  <Typography sx={{ fontSize: "17", fontFamily: "Almarai" }}>
                    رقم الهاتف
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                inputProps={{ maxLength: 120 }}
                type="text"
                label="العنوان"
                variant="outlined"
                value={Addreess}
                onChange={(e) => setAddreess(e.target.value)}
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label="ملاحظات"
                inputProps={{ maxLength: 120 }}
                type="text"
                value={Note}
                onChange={(e) => setNote(e.target.value)}
                variant="outlined"
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label="أرشيف المستندات"
                variant="outlined"
                inputProps={{ maxLength: 120 }}
                type="text"
                value={NoteImg}
                onChange={(e) => setNoteImg(e.target.value)}
                //   className="ww"
              />
              <i
                onClick={importData}
                className="ty fa-solid fa-paperclip"
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              {selectedFile && (
                <div className="fi">
                  <a
                    href={FileeBase64 ? FileeBase64 : selectedFile}
                    target="blank"
                    download={selectedFile.name}>
                    {selectedFile.name ? (
                      selectedFile.name
                    ) : (
                      <i
                        className=" fa-solid fa-paperclip"
                        style={{ color: "#1866ec" }}></i>
                    )}
                  </a>
                  <div style={{ display: "block" }}>Attach File</div>
                  <button
                    style={{ background: "transparent" }}
                    className="buttonadd d">
                    <i
                      onClick={(idx) => deleteFile(idx)}
                      className="fs fa-solid fa-trash-can icon-red"
                      style={{ color: "red" }}></i>
                  </button>
                </div>
              )}
            </div>

            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
          {Eye ? null : (
            <>
              {isEdit ? (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handleUpdate}>
                      تعديل
                    </button>
                  )}
                </>
              ) : (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handlesubmit}>
                      إضافة
                    </button>
                  )}
                </>
              )}
            </>
          )}{" "}
          <div className="inp-container">
            <TextField
              onChange={(e) => setSearch(e.target.value)}
              value={Search}
              label={"ابحث"}
              variant="outlined"
              //   className="ww"
            />
          </div>
          {/* <div className="inputs-container">
            <div className="inp-container ">
              {" "}
              <TextField
                
                label="ابحث"
                variant="outlined"
                //   className="ww"
              />
              <i className="ty fa-solid fa-magnifying-glass"></i>
            </div>{" "}
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div> */}
        </Container>{" "}
        <Table
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                اسم الموكل <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                رقم الهاتف <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                العنوان <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                الوصف <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                ارشيف المستندات <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {ALL && ALL.Data
              ? ALL.Data.map((item) => (
                  <tr key={item.Id} onDoubleClick={() => Update(item)}>
                    <td>{item.Name}</td>
                    <td>{item.phoneNumber}</td>
                    <td>{item.Address}</td>
                    <td>{item.Note}</td>
                    <td>
                      {" "}
                      {item.FileUrl !== null ? (
                        <>
                          <button
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                            }}
                            onClick={() => handleShowpopup(item.FileUrl)}>
                            {" "}
                            <i className="fa-solid fa-paperclip"></i>
                          </button>
                          <span>{item.FileDescription}</span>
                        </>
                      ) : (
                        " "
                      )}
                    </td>
                    <td className="icon-w" onClick={() => Update(item)}>
                      <i
                        className="fa fa-solid fa-pen-to-square icon-blue"
                        style={{ color: "#333" }}></i>
                    </td>
                    <td className="icon-w">
                      {" "}
                      <i
                        onClick={() => handleShoweDelete(item.Id)}
                        className="fs fa-solid fa-trash-can icon-red"
                        style={{ color: "#333" }}></i>
                    </td>
                    <td className="icon-w">
                      <i
                        onClick={() => HandleEye(item)}
                        className="fa-solid fa-eye"
                        style={{ color: "#333" }}></i>
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </Table>
      </div>
      {/* <Pagination
        onPress={onPress}
        // PageSize={PageSize}
        PageCount={ALL ? ALL.totalCount : null}
        // ForceCount={ForceCount}
        // itemsPerPage={2}
        // items={FilesDetails.data}
      /> */}
      <ToastContainer autoClose={1200} />
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          {/* <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header> */}
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div className="popimg">
        <Modal
          show={popup}
          onHide={handleClosepopup}
          backdrop="static"
          centered
          keyboard={false}
          contentClassName="popimg"
          style={{ width: "90%", margin: "0px auto", textAlign: "center" }}>
          <Modal.Header closeButton>
            <Modal.Title>عرض المستند</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <img src={ContentFile} alt="" />
            ) : (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`
                  )
                }>
                تحميل ملف بصيغة {ContentFile.split(".").pop().toLowerCase()}{" "}
                <i className="fa-solid fa-file-export"></i>
              </Button>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleClosepopup}>
              إغلاق
            </Button>
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`
                  )
                }
                // onClick={() =>
                //   downloadFile({ url: ContentFile, filename: "newfile.png" })
                // }
              >
                تحميل الصورة
              </Button>
            ) : null}
            {/* <a  href={ContentFile}  className="close" >
            تحميل الملف
          </a> */}
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
export default Namemowakel;
